import request from '@/utils/request'

let ElasticsearchApi = {

  /*设置详情*/
  esDetail(data, errorback) {
    return request._get('/shop/plus.elasticsearch.elasticsearch/index', data, errorback);
  },
  /*保存设置*/
  editConfig(data, errorback) {
    return request._post('/shop/plus.elasticsearch.elasticsearch/setEsConfig', data, errorback);
  },

  /*一键同步*/
  oneClickSync(data, errorback) {
    return request._post('/shop/plus.elasticsearch.elasticsearch/syncData', data, errorback);
  },
}

export default ElasticsearchApi;



// WEBPACK FOOTER //
// ./src/api/elasticsearch.js